// extracted by mini-css-extract-plugin
export var arrows = "_61-6";
export var decrementer = "_61-a";
export var disabled = "_61-4";
export var error = "_61-1";
export var hiddenText = "_61-b";
export var incrementer = "_61-9";
export var input = "_61-8";
export var inputWrapper = "_61-0";
export var leadingIcon = "_61-c";
export var readonly = "_61-3";
export var regular = "_61-7";
export var small = "_61-5";
export var warning = "_61-2";